var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"card light mn"},[_c('div',{staticClass:"content gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Pay: ")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.currentPay)+" Kč/hod ("+_vm._s(Math.round((_vm.currentPay * 8 * 252) / 12 / 1000) * 1000)+" Kč/měsíc) ")])])]),_c('a',{staticClass:"heading-title-2"},[_vm._v("Pay")]),_c('Table',{attrs:{"items":_vm.pay,"defaultColumn":0,"columns":[
      {
        name: 'Date',
        sort: 'date',
        path: ['date'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Created By',
        sort: 'alphabet',
        path: ['createdBy', 'fullName'],
      },
      {
        name: 'Pay',
        sort: 'numeric',
        path: ['amount'],
        formatMap: (amount) =>
          `${Math.round(amount)} Kč/hod (${
            Math.round((amount * 8 * 252) / 12 / 1000) * 1000
          } Kč/měsíc)`,
      },
    ]}}),_c('div',{staticClass:"h-stack h-end"},[(_vm.$store.state.accessLevel > 9)?_c('button',{staticClass:"add",on:{"click":function($event){_vm.$router.push('/users/pay/new/' + (_vm.id || _vm.$store.state.id))}}},[_vm._v(" Add ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }